import '!ng-cache-loader!./BuilderRulesView.html';
import { CloseEditorIfOpenedEvent } from '../BuilderController';
import { BuilderAttendanceRulesSidebarFeatures } from './BuilderAttendanceRulesSidebarFeatures';
import { v4 as uuid } from 'uuid';
import './builderRules.scss';
import { debounce } from 'data/function';
import { RulesConstants } from 'modules/application/detail/attendance/rules/RulesConstants';
import { ToastType } from 'modules/application/misc/ToastService';
export class BuilderAttendanceRulesSidebarController {
    static $inject = ['close', 'flow', 'flowId', 'configuration', 'globalActions', '$onChanged', 'SidebarContentService', 'application', 'canEditRule', 'canSeeRule', 'TeamService', 'LoadingService', '$timeout', 'SegmentService', 'RulesService', 'ModalService', '$translate', 'ngToast', '$state', 'ChatService', '$rootScope', '$scope', 'AlertService', 'LoadValues', 'BuilderTabsService'];
    constructor(close, flow, flowId, configuration, globalActions, $onChanged, SidebarContentService, application, canEditRule, canSeeRule, TeamService, LoadingService, $timeout, SegmentService, RulesService, ModalService, $translate, ngToast, $state, ChatService, $rootScope, $scope, AlertService, LoadValues, BuilderTabsService) {
        this.close = close;
        this.flow = flow;
        this.flowId = flowId;
        this.configuration = configuration;
        this.globalActions = globalActions;
        this.$onChanged = $onChanged;
        this.SidebarContentService = SidebarContentService;
        this.application = application;
        this.canEditRule = canEditRule;
        this.canSeeRule = canSeeRule;
        this.TeamService = TeamService;
        this.LoadingService = LoadingService;
        this.$timeout = $timeout;
        this.SegmentService = SegmentService;
        this.RulesService = RulesService;
        this.ModalService = ModalService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.$state = $state;
        this.ChatService = ChatService;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.AlertService = AlertService;
        this.LoadValues = LoadValues;
        this.BuilderTabsService = BuilderTabsService;
        this.publishedVersionNameEditing = -1;
        this.currentState = RulesConstants.STATES.VIEWING;
        // Needed to use {{ ... }} chars escaped in angular translate
        this.translateConfigDescriptionString = '{{config.VariableName}}';
        this.isDeepChange = true;
        this.hasArrow = false;
        this.inputTextSearchRules = '';
        this.canEditRuleCtrl = false;
        this.canSeeRuleCtrl = false;
        this.isInQueueMode = true;
        this.isInRuleMode = false;
        this.searchRule = async (event) => {
            this.inputTextSearchRules = event.detail.value;
            await this.fetchRules();
            this.rules = this.rules.filter((rule) => {
                return rule.title.toLowerCase().includes(this.inputTextSearchRules.toLowerCase());
            });
        };
        this.startEditingTitle = async (event, index) => {
            const input = document.getElementById(`rule-title-${index}`);
            if (input) {
                input.focus();
                if (!this.rules[index].opened) {
                    this.rules[index].opened = true;
                }
                else {
                    event.stopPropagation();
                }
            }
        };
        this.init();
    }
    async init() {
        await this.checkFeatures();
        this.BuilderTabsService.validateTab('content-tab-2', this.globalActions);
        if (this.ChatService.built) {
            this.ChatService.destroy();
        }
        this.debouncedSearch = debounce(this.searchRule, 500);
        this.properties = await this.LoadValues.loadProperties();
        this.relations = await this.LoadValues.loadRelations();
        this.operators = await this.LoadValues.loadOperators();
        this.teams = await this.RulesService.fetchTeams(this.application);
        await this.fetchRules();
    }
    activateQueueMode() {
        this.isInRuleMode = false;
        this.isInQueueMode = true;
    }
    activateRuleMode(queue) {
        this.selectedQueueName = queue.name;
        this.selectedQueueId = queue.id;
        this.isInQueueMode = false;
        this.isInRuleMode = true;
    }
    async checkFeatures() {
        this.isAttendanceRulesBuilderEnabled = await BuilderAttendanceRulesSidebarFeatures.attendanceRulesBuilderEnabled();
        this.isQueueManagementInBuilderEnabled = await BuilderAttendanceRulesSidebarFeatures.queueManagementInBuilderEnabled();
    }
    async raiseOnChanged(data) {
        await this.$onChanged(this.globalActions);
    }
    async validateTab() {
        await this.BuilderTabsService.validateTab('content-tab-2', this.globalActions);
    }
    async fetchRules() {
        this.rules = await this.RulesService.fetchRules(this.application) ?? [];
    }
    async closeSidebar() {
        try {
            if (!this.ChatService.built) {
                this.ChatService.build();
            }
            this.$rootScope.$broadcast(CloseEditorIfOpenedEvent);
            await this.close();
        }
        catch (e) {
            console.error(e);
        }
    }
    async changeStatus(value, index) {
        if (this.canEditRule) {
            const rule = {
                ...this.rules[index],
                isActive: value,
            };
            this.saveRule(rule, index);
        }
        else {
            this.rules[index].isActive = !value;
            const translationKey = 'builder-attendance-rules.errors.cannotEdit';
            this.RulesService.showToast(translationKey, ToastType.Danger);
        }
    }
    async createRule() {
        const title = await this.$translate('builder-attendance-rules.rules.ruleName');
        const newRule = {
            id: uuid(),
            title: `${title} ${this.rules.length + 1}`,
            conditions: [{
                    property: 'Message',
                    relation: 'Contains',
                    values: [],
                }],
            team: RulesConstants.DEFAULT_TEAM_NAME,
            isActive: true,
            opened: true,
            operator: RulesConstants.DEFAULT_OPERATOR,
            repeatConditionsBody: false,
        };
        this.rules = this.rules.concat(newRule);
        await this.saveRule(newRule, this.rules.length - 1);
        const input = document.getElementById(`rule-title-${this.rules.length - 1}`);
        if (input) {
            input.focus();
            this.rules[this.rules.length - 1].opened = true;
        }
        this.SegmentService.createBotTrack('builder-helpdesk-rule-added', this.application);
    }
    clearSearch() {
        this.inputTextSearchRules = '';
        const input = document.getElementById('input-search-value');
        if (input) {
            input.value = this.inputTextSearchRules;
        }
    }
    async editRule(index) {
        this.setCurrentState(RulesConstants.STATES.EDITING);
        await this.changeStatusItem(index);
    }
    async changeStatusItem(index) {
        for (const [i, rule] of this.rules.entries()) {
            rule.opened = i === index ? !rule.opened : false;
        }
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    async saveTitle(rule, index) {
        if (!this.canEditRule) {
            const errorMsg = await this.$translate('builder-attendance-rules.errors.cannotEdit');
            this.ngToast.danger(errorMsg);
            this.rules[index] = await this.RulesService.getRule(rule.id);
            return;
        }
        if (rule.title) {
            this.saveRule(rule, index);
        }
    }
    async saveRule(data, index) {
        let rule;
        if (!data.id) {
            rule = {
                id: uuid(),
                title: data.title,
                team: data.team ? data.team : RulesConstants.DEFAULT_TEAM_NAME,
                conditions: data.conditions,
                isActive: data.isActive,
            };
        }
        else {
            rule = { ...data };
        }
        try {
            await this.RulesService.set(this.application, rule);
        }
        catch (ex) {
            const errorMsg112 = 'utils.errorMsg.112';
            this.RulesService.showToast(errorMsg112, ToastType.Danger);
        }
    }
    async confirmDelete(rule) {
        try {
            const modalTitle = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteTitle');
            const modalBody = await this.$translate('modules.application.detail.attendance.rules.builder.confirmDeleteBody');
            const confirm = await this.$translate('utils.forms.exclude');
            const cancel = await this.$translate('utils.forms.cancel');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => {
                    },
                    confirmButtonAction: () => this.delete(rule),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async delete(rule) {
        let toastType;
        let messageTranslationKey;
        try {
            this.LoadingService.startLoading();
            this.RulesService.delete(rule);
            this.rules = this.rules.filter((obj) => obj.id !== rule.id);
            messageTranslationKey = 'utils.successMsg.31';
            toastType = ToastType.Success;
            this.SegmentService.createBotTrack('builder-helpdesk-rule-deleted', this.application);
        }
        catch (e) {
            messageTranslationKey = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            this.RulesService.showToast(messageTranslationKey, toastType);
            this.LoadingService.stopLoading();
        }
    }
    isAnyRuleOpen() {
        return this.rules.some(r => r.opened);
    }
}
BuilderAttendanceRulesSidebarController.$inject = ['close', 'flow', 'flowId', 'configuration', 'globalActions', '$onChanged', 'SidebarContentService', 'application', 'canEditRule', 'canSeeRule', 'TeamService', 'LoadingService', '$timeout', 'SegmentService', 'RulesService', 'ModalService', '$translate', 'ngToast', '$state', 'ChatService', '$rootScope', '$scope', 'AlertService', 'LoadValues', 'BuilderTabsService'];
